import React, {forwardRef, ReactNode, useRef} from "react";

import {RadioCheckedIcon, RadioIcon} from "@pg-design/icons-module";
import {FILTERS_TEST_IDS} from "@pg-mono/e2e-test-utils";

import {IRadioOnChange} from "../types/IRadioOnChange";
import {IRadioValue} from "../types/IRadioValue";

import {
    componentContainerNotReadOnlyStyle,
    componentContainerReadOnlyStyle,
    hiddenInputStyle,
    labelContainerStyle,
    radioActiveMarkStyle,
    radioActiveMarkSvgStyle,
    radioContainerStyle,
    radioFrameStyle,
    radioFrameSvgStyle,
    radioWrapperStyle,
    radioWrapStyle
} from "./Radio.module.css";

//  Types
export type IRadioProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "type" | "onChange" | "checked"> & {
    name: string;
    value: IRadioValue;
    id: string;
    onChange: (name: string, isActive: boolean, value: IRadioValue) => void;
    labelContent?: ReactNode | string;
    isActive?: boolean;
    dataTestId?: string;
};

// Component
export const Radio = forwardRef<HTMLInputElement, IRadioProps>((props, forwardedRef) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {isActive, onChange, autoFocus, readOnly, labelContent, id, ...inputProps} = props;
    const radioRef = forwardedRef ? useRef<HTMLInputElement | null>(null) : (forwardedRef as unknown as React.MutableRefObject<HTMLInputElement>);

    const componentContainerStyle = readOnly ? componentContainerReadOnlyStyle : componentContainerNotReadOnlyStyle;
    const radioFrameFill = readOnly ? "var(--colors-gray-300)" : "var(--colors-gray-700)";
    const radioActiveMarkSvgFill = readOnly ? "var(--colors-gray-300)" : "#02D054";
    const radioActiveMarkOpacity = {opacity: isActive ? 100 : 0};

    return (
        <div className={componentContainerStyle}>
            <div className={radioWrapperStyle}>
                <input
                    {...inputProps}
                    type="radio"
                    checked={isActive}
                    onChange={({target: {checked, value, name}}) => {
                        if (!readOnly && onChange) {
                            (onChange as IRadioOnChange)(name, checked, value);
                        }
                    }}
                    id={id}
                    ref={radioRef}
                    className={hiddenInputStyle}
                />
                <div className={radioWrapStyle}>
                    <div className={radioContainerStyle}>
                        {isActive ? (
                            <div className={radioActiveMarkStyle} style={radioActiveMarkOpacity}>
                                <RadioCheckedIcon className={radioActiveMarkSvgStyle} fill={radioActiveMarkSvgFill} />
                            </div>
                        ) : (
                            <div className={radioFrameStyle}>
                                <RadioIcon className={radioFrameSvgStyle} fill={radioFrameFill} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {labelContent && (
                <label
                    className={labelContainerStyle}
                    onClick={() => {
                        if (!readOnly && onChange && radioRef?.current) {
                            const {name, value, checked} = radioRef.current;
                            (onChange as IRadioOnChange)(name, !checked, value);
                        }
                    }}
                    htmlFor={id}
                    data-testid={FILTERS_TEST_IDS.FILTERS_BOX}
                >
                    {labelContent}
                </label>
            )}
        </div>
    );
});
import React, {forwardRef, ReactNode, useRef} from "react";

import {RadioCheckedIcon, RadioIcon} from "@pg-design/icons-module";
import {FILTERS_TEST_IDS} from "@pg-mono/e2e-test-utils";

import {IRadioOnChange} from "../types/IRadioOnChange";
import {IRadioValue} from "../types/IRadioValue";

import {
    componentContainerNotReadOnlyStyle,
    componentContainerReadOnlyStyle,
    hiddenInputStyle,
    labelContainerStyle,
    radioActiveMarkStyle,
    radioActiveMarkSvgStyle,
    radioContainerStyle,
    radioFrameStyle,
    radioFrameSvgStyle,
    radioWrapperStyle,
    radioWrapStyle
} from "./Radio.module.css";

//  Types
export type IRadioProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "type" | "onChange" | "checked"> & {
    name: string;
    value: IRadioValue;
    id: string;
    onChange: (name: string, isActive: boolean, value: IRadioValue) => void;
    labelContent?: ReactNode | string;
    isActive?: boolean;
    dataTestId?: string;
};

// Component
export const Radio = forwardRef<HTMLInputElement, IRadioProps>((props, forwardedRef) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {isActive, onChange, autoFocus, readOnly, labelContent, id, ...inputProps} = props;
    const radioRef = forwardedRef ? useRef<HTMLInputElement | null>(null) : (forwardedRef as unknown as React.MutableRefObject<HTMLInputElement>);

    const componentContainerStyle = readOnly ? componentContainerReadOnlyStyle : componentContainerNotReadOnlyStyle;
    const radioFrameFill = readOnly ? "var(--colors-gray-300)" : "var(--colors-gray-700)";
    const radioActiveMarkSvgFill = readOnly ? "var(--colors-gray-300)" : "#02D054";
    const radioActiveMarkOpacity = {opacity: isActive ? 100 : 0};

    return (
        <div className={componentContainerStyle}>
            <div className={radioWrapperStyle}>
                <input
                    {...inputProps}
                    type="radio"
                    checked={isActive}
                    onChange={({target: {checked, value, name}}) => {
                        if (!readOnly && onChange) {
                            (onChange as IRadioOnChange)(name, checked, value);
                        }
                    }}
                    id={id}
                    ref={radioRef}
                    className={hiddenInputStyle}
                />
                <div className={radioWrapStyle}>
                    <div className={radioContainerStyle}>
                        {isActive ? (
                            <div className={radioActiveMarkStyle} style={radioActiveMarkOpacity}>
                                <RadioCheckedIcon className={radioActiveMarkSvgStyle} fill={radioActiveMarkSvgFill} />
                            </div>
                        ) : (
                            <div className={radioFrameStyle}>
                                <RadioIcon className={radioFrameSvgStyle} fill={radioFrameFill} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {labelContent && (
                <label
                    className={labelContainerStyle}
                    onClick={() => {
                        if (!readOnly && onChange && radioRef?.current) {
                            const {name, value, checked} = radioRef.current;
                            (onChange as IRadioOnChange)(name, !checked, value);
                        }
                    }}
                    htmlFor={id}
                    data-testid={FILTERS_TEST_IDS.FILTERS_BOX}
                >
                    {labelContent}
                </label>
            )}
        </div>
    );
});
